var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgOrangeChatbotIcon1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2916",
  d: "M0 0h30v30H0z",
  fill: "none"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2917",
  d: "M22.385 21.77s.1-.07.255-.191a9.4 9.4 0 003.819-7.406c0-5.483-5.13-9.932-11.456-9.932S3.545 8.691 3.545 14.174s5.132 9.778 11.458 9.778q.81 0 2.658-.107a11.868 11.868 0 006 1.91.618.618 0 00.527-1.059 11.633 11.633 0 01-1.8-2.929z",
  fill: "none",
  stroke: "#f96507",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2918",
  d: "M9.683 16.953a7.488 7.488 0 0010.633 0",
  fill: "none",
  stroke: "#f96507",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})));
export default __webpack_public_path__ + "static/OrangeChatbotIcon1.00b4f06907a38b225b3152c5375f8da9.svg";
export { SvgOrangeChatbotIcon1 as ReactComponent };